<div class="toast ngx-toastr"
     [ngClass]="'toast-' + toastPackage.toastType"
     [@flyInOut]="'visible'">

  <!-- ICÔNE ACCESSIBLE -->
  <div class="toast-icon">
    <em
      class="mdi {{ iconClass }}"
      [attr.aria-labelledby]="id"
      [attr.tooltip]="tooltip"
    ></em>
  </div>

  <!-- TEXTE -->
  <div class="toast-message-wrapper">
    <span [id]="id" class="sr-only">{{ tooltip }}</span>
    <div class="toast-title" *ngIf="title">{{ title }}</div>
    <div class="toast-message" [innerHTML]="message"></div>
  </div>

</div>
